import { render, staticRenderFns } from "./TgLiveContentCardComment.vue?vue&type=template&id=48874708&"
import script from "./TgLiveContentCardComment.vue?vue&type=script&lang=js&"
export * from "./TgLiveContentCardComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports